module.exports = __webpack_public_path__ + "static/img/20.4e040c0d.jpg";